import fileDownload from "js-file-download";
import companyService from "../shared/services/companyService";
import CookieService from "../shared/services/cookiesService";
import getDates from "../shared/services/date.service";
import { downloadFile } from "../shared/services/download.service";
import configuration from "./../config.json";
import { setLogin } from "./authActions";

const REQUEST_COMPANIES = "REQUEST_COMPANIES";
const RESPONSE_COMPANIES = "RESPONSE_COMPANIES";
const REQUEST_COMPANIES_FAILURE = "REQUEST_COMPANIES_FAILURE";

const requestCompaniesAction = () => {
  return {
    type: REQUEST_COMPANIES,
  };
};

const responseCompaniesAction = (data) => {
  return {
    type: RESPONSE_COMPANIES,
    data,
  };
};

const requestCompaniesFailureAction = (errors) => {
  return {
    type: REQUEST_COMPANIES_FAILURE,
    errors,
  };
};

const getCompanies = (options) => {
  return (dispatch) => {
    dispatch(requestCompaniesAction());

    companyService
      .getCompanies(options)
      .then((result) => {
        const data = result.data;

        data.ownershipAreas = result.data.ownershipAreas.map((area) => {
          area.companies = area.companies.map((x) => {
            x.dateCreation = new Date(Date.parse(x.dateCreation));
            x.datePayment = new Date(Date.parse(x.datePayment));

            return x;
          });

          return area;
        });
        dispatch(responseCompaniesAction(data));
      })
      .catch((error) => {
        dispatch(requestCompaniesFailureAction(error.response));
      });
  };
};

const REQUEST_COMPANIES_TO_OWNERSHIP = "REQUEST_COMPANIES_TO_OWNERSHIP";
const RESPONSE_COMPANIES_TO_OWNERSHIP = "RESPONSE_COMPANIES_TO_OWNERSHIP";
const REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE = "REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE";

const requestCompaniesToOwnershipAction = () => {
  return {
    type: REQUEST_COMPANIES_TO_OWNERSHIP,
  };
};

const responseCompaniesToOwnershipAction = (id, toId, data) => {
  return {
    type: RESPONSE_COMPANIES_TO_OWNERSHIP,
    id,
    toId,
    data,
  };
};

const requestCompaniesToOwnershipFailureAction = (errors) => {
  return {
    type: REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE,
    errors,
  };
};

const setCompaniesToOwnership = (id, toId, options) => {
  return (dispatch) => {
    dispatch(requestCompaniesToOwnershipAction());

    companyService
      .setCompaniesToOwnership(toId, options)
      .then((result) => {
        dispatch(responseCompaniesToOwnershipAction(id, toId, options));
      })
      .catch((error) => {
        dispatch(requestCompaniesToOwnershipFailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_COMPANY = "REQUEST_UPDATE_COMPANY";
const RESPONSE_UPDATE_COMPANY = "RESPONSE_UPDATE_COMPANY";
const REQUEST_UPDATE_COMPANY_FAILURE = "REQUEST_UPDATE_COMPANY_FAILURE";

const requestUpdateCompanyAction = () => {
  return {
    type: REQUEST_UPDATE_COMPANY,
  };
};

const responseUpdateCompanyAction = (data) => {
  return {
    type: RESPONSE_UPDATE_COMPANY,
    data,
  };
};

const requestUpdateCompanyFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_COMPANY_FAILURE,
    errors,
  };
};

const updateCompany = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateCompanyAction());

    companyService
      .updateCompany(options)
      .then((result) => {
        dispatch(responseUpdateCompanyAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateCompanyFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_OWNERSHIPAREA = "REQUEST_CREATE_OWNERSHIPAREA";
const RESPONSE_CREATE_OWNERSHIPAREA = "RESPONSE_CREATE_OWNERSHIPAREA";
const REQUEST_CREATE_OWNERSHIPAREA_FAILURE = "REQUEST_CREATE_OWNERSHIPAREA_FAILURE";

const requestCreateOwnershipAreaAction = () => {
  return {
    type: REQUEST_CREATE_OWNERSHIPAREA,
  };
};

const responseCreateOwnershipAreaAction = (data) => {
  return {
    type: RESPONSE_CREATE_OWNERSHIPAREA,
    data,
  };
};

const requestCreateOwnershipAreaFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_OWNERSHIPAREA_FAILURE,
    errors,
  };
};

const createOwnershipArea = (options) => {
  return (dispatch) => {
    dispatch(requestCreateOwnershipAreaAction());

    companyService
      .createOwnershipArea(options)
      .then((result) => {
        options.id = result.data.id;
        dispatch(responseCreateOwnershipAreaAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateOwnershipAreaFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_COMPANY = "REQUEST_CREATE_COMPANY";
const RESPONSE_CREATE_COMPANY = "RESPONSE_CREATE_COMPANY";
const REQUEST_CREATE_COMPANY_FAILURE = "REQUEST_CREATE_COMPANY_FAILURE";

const requestCreateCompanyAction = () => {
  return {
    type: REQUEST_CREATE_COMPANY,
  };
};

const responseCreateCompanyAction = (ownershipAreaId, data) => {
  return {
    type: RESPONSE_CREATE_COMPANY,
    ownershipAreaId,
    data,
  };
};

const requestCreateCompanyFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_COMPANY_FAILURE,
    errors,
  };
};

const createCompany = (options) => {
  return (dispatch) => {
    dispatch(requestCreateCompanyAction());

    companyService
      .createCompany(options)
      .then((result) => {
        dispatch(responseCreateCompanyAction(options.ownershipAreaId, result.data));
      })
      .catch((error) => {
        dispatch(requestCreateCompanyFailureAction(error.response));
      });
  };
};

const REQUEST_COMPANY = "REQUEST_COMPANY";
const RESPONSE_COMPANY = "RESPONSE_COMPANY";
const REQUEST_COMPANY_FAILURE = "REQUEST_COMPANY_FAILURE";

const requestCompanyAction = () => {
  return {
    type: REQUEST_COMPANY,
  };
};

const responseCompanyAction = (data) => {
  return {
    type: RESPONSE_COMPANY,
    data,
  };
};

const requestCompanyFailureAction = (errors) => {
  return {
    type: REQUEST_COMPANY_FAILURE,
    errors,
  };
};

const getCompany = (id) => {
  return (dispatch) => {
    dispatch(requestCompanyAction());

    companyService
      .getCompany(id)
      .then((result) => {
        dispatch(responseCompanyAction(result.data));
      })
      .catch((error) => {
        dispatch(requestCompanyFailureAction(error.response));
      });
  };
};

const REQUEST_TRANSFER_UNITS_TO_COMPANY = "REQUEST_TRANSFER_UNITS_TO_COMPANY";
const RESPONSE_TRANSFER_UNITS_TO_COMPANY = "RESPONSE_TRANSFER_UNITS_TO_COMPANY";
const REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE = "REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE";

const requestTransferUnitsToCompanyAction = () => {
  return {
    type: REQUEST_TRANSFER_UNITS_TO_COMPANY,
  };
};

const responseTransferUnitsToCompanyAction = (data) => {
  return {
    type: RESPONSE_TRANSFER_UNITS_TO_COMPANY,
    data,
  };
};

const requestTransferUnitsToCompanyFailureAction = (errors) => {
  return {
    type: REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE,
    errors,
  };
};

const transferUnitsToCompany = (id, units) => {
  return (dispatch) => {
    dispatch(requestTransferUnitsToCompanyAction());

    companyService
      .transferUnitsToCompany(id, units)
      .then((result) => {
        dispatch(responseTransferUnitsToCompanyAction(units));
      })
      .catch((error) => {
        dispatch(requestTransferUnitsToCompanyFailureAction(error.response));
      });
  };
};

const REQUEST_ENTERING_COMPANY = "REQUEST_ENTERING_COMPANY";
const RESPONSE_ENTERING_COMPANY = "RESPONSE_ENTERING_COMPANY";
const REQUEST_ENTERING_COMPANY_FAILURE = "REQUEST_ENTERING_COMPANY_FAILURE";

const requestEnteringCompanyAction = () => {
  return {
    type: REQUEST_ENTERING_COMPANY,
  };
};

const responseEnteringCompanyAction = () => {
  return {
    type: RESPONSE_ENTERING_COMPANY,
  };
};

const requestEnteringFailureAction = (errors) => {
  return {
    type: REQUEST_ENTERING_COMPANY_FAILURE,
    errors,
  };
};

const enteringCompany = (company) => {
  return (dispatch) => {
    dispatch(requestEnteringCompanyAction());

    companyService
      .enteringCompany(company.id)
      .then((result) => {
        const authCookie = JSON.parse(CookieService.getCookie(configuration.cookieName));
        authCookie.companyTitle = company.title;

        const companyIdItems = company.id.split("-");
        authCookie.companyId = companyIdItems[0];
        CookieService.setCookie(configuration.cookieName, JSON.stringify(authCookie));

        dispatch(
          setLogin({
            authState: true,
            email: authCookie.email,
            companyTitle: authCookie.companyTitle,
            companyId: authCookie.companyId,
            userTitle: authCookie.userTitle,
            permissions: authCookie.permissions,
          })
        );

        dispatch(responseEnteringCompanyAction());
      })
      .catch((error) => {
        dispatch(requestEnteringFailureAction(error.response));
      });
  };
};

const REQUEST_DOWNLOAL_COMPANY_INFO = "REQUEST_DOWNLOAL_COMPANY_INFO";
const RESPONSE_DOWNLOAL_COMPANY_INFO = "RESPONSE_DOWNLOAL_COMPANY_INFO";
const REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE = "REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE";

const requestDownloadCompanyInfoAction = () => {
  return {
    type: REQUEST_DOWNLOAL_COMPANY_INFO,
  };
};

const responseDownloadCompanyInfoAction = () => {
  return {
    type: RESPONSE_DOWNLOAL_COMPANY_INFO,
  };
};

const requestDownloadCompanyInfoActionFailure = (errors) => {
  return {
    type: REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE,
    errors,
  };
};

const downloadCompanyInfo = (company, options) => {
  return (dispatch) => {
    dispatch(requestDownloadCompanyInfoAction());

    companyService
      .downloadCompanyInfo(company.id, options)
      .then((result) => {
        let title = company.title;

        if (options.activeType !== 0) {
          title += ` ${options.activeType === 1 ? "Активные" : "Неактивные"}`;
        }

        if (options.rentType !== 0) {
          title += ` ${options.rentType === 1 ? "Арендованые" : "Неарендоавные"}`;
        }

        title += ` ${getDates.getDateFormat9(new Date())}`;

        fileDownload(result.data, `${title}.xlsx`);
        dispatch(responseDownloadCompanyInfoAction());
      })
      .catch((error) => {
        dispatch(requestDownloadCompanyInfoActionFailure(error.response));
      });
  };
};

export {
  REQUEST_COMPANIES,
  RESPONSE_COMPANIES,
  REQUEST_COMPANIES_FAILURE,
  getCompanies,
  REQUEST_COMPANIES_TO_OWNERSHIP,
  RESPONSE_COMPANIES_TO_OWNERSHIP,
  REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE,
  setCompaniesToOwnership,
  REQUEST_UPDATE_COMPANY,
  RESPONSE_UPDATE_COMPANY,
  REQUEST_UPDATE_COMPANY_FAILURE,
  updateCompany,
  REQUEST_CREATE_OWNERSHIPAREA,
  RESPONSE_CREATE_OWNERSHIPAREA,
  REQUEST_CREATE_OWNERSHIPAREA_FAILURE,
  createOwnershipArea,
  REQUEST_CREATE_COMPANY,
  RESPONSE_CREATE_COMPANY,
  REQUEST_CREATE_COMPANY_FAILURE,
  createCompany,
  REQUEST_COMPANY,
  RESPONSE_COMPANY,
  REQUEST_COMPANY_FAILURE,
  getCompany,
  REQUEST_TRANSFER_UNITS_TO_COMPANY,
  RESPONSE_TRANSFER_UNITS_TO_COMPANY,
  REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE,
  transferUnitsToCompany,
  REQUEST_ENTERING_COMPANY,
  RESPONSE_ENTERING_COMPANY,
  REQUEST_ENTERING_COMPANY_FAILURE,
  enteringCompany,
  REQUEST_DOWNLOAL_COMPANY_INFO,
  RESPONSE_DOWNLOAL_COMPANY_INFO,
  REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE,
  downloadCompanyInfo,
};
